var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuobi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 18,
    viewBox: "0 0 57 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_7984)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7998 4.84913V9.65131H16.0612V5.46687C16.0612 5.1257 15.7845 4.84913 15.4431 4.84913H13.8438V16.2928C13.8438 16.6341 14.1204 16.9107 14.4619 16.9107H16.0612V11.588H20.7998V16.2928C20.7998 16.6341 21.0765 16.9107 21.4179 16.9107H23.0172V5.46687C23.0172 5.1257 22.7405 4.84913 22.399 4.84913H20.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1012 7.69276V13.4084C30.1012 13.9278 29.8363 14.4201 29.3864 14.6799C28.1307 15.4051 26.8313 14.4992 26.8313 13.3048V8.31052C26.8313 7.96933 26.5546 7.69276 26.2132 7.69276H24.6074V13.5084C24.6074 15.3797 26.1391 16.9107 28.0112 16.9107H28.9213C30.7935 16.9107 32.3251 15.3797 32.3251 13.5084V8.31052C32.3251 7.96933 32.0485 7.69276 31.7071 7.69276H30.1012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7665 16.9107H56.3659V8.81665C56.3659 8.47532 56.089 8.19874 55.7477 8.19874H54.1484V16.2928C54.1484 16.6341 54.4252 16.9107 54.7665 16.9107Z",
    fill: "#2483FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.257 7.32163C55.9405 7.32163 56.4946 6.76778 56.4946 6.08459C56.4946 5.4014 55.9405 4.84769 55.257 4.84769C54.5735 4.84769 54.0195 5.4014 54.0195 6.08459C54.0195 6.76778 54.5735 7.32163 55.257 7.32163Z",
    fill: "#2483FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1286 13.0834C40.1286 14.1831 39.2287 14.915 38.1286 14.915C37.0284 14.915 36.1283 14.1831 36.1283 13.0834V11.5142C36.1283 10.4145 37.0284 9.68252 38.1286 9.68252C39.2287 9.68252 40.1286 10.4145 40.1286 11.5142V13.0834ZM38.1286 7.687C35.8025 7.687 33.8994 9.3501 33.8994 11.675V12.9325C33.8994 15.2574 35.8025 16.9106 38.1286 16.9106C40.4544 16.9106 42.3577 15.2574 42.3577 12.9325V11.675C42.3577 9.3501 40.4544 7.687 38.1286 7.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1942 13.0834C50.1942 14.1831 49.2942 14.9151 48.194 14.9151C47.094 14.9151 46.1937 14.1831 46.1937 13.0834V11.5142C46.1937 10.4145 47.094 9.68255 48.194 9.68255C49.2942 9.68255 50.1942 10.4145 50.1942 11.5142V13.0834ZM48.194 7.68703C47.467 7.68703 46.7815 7.84951 46.1824 8.14385V5.45652C46.1824 5.1152 45.9056 4.83863 45.5643 4.83863H43.9648V12.9325C43.9648 15.2575 45.868 16.9106 48.194 16.9106C50.52 16.9106 52.4231 15.2575 52.4231 12.9325V11.675C52.4231 9.35014 50.52 7.68703 48.194 7.68703Z",
    fill: "#2483FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2043 5.68627C7.2043 3.28439 6.03371 1.2189 5.14336 0.546289C5.13969 0.544173 5.07521 0.507926 5.08071 0.603973L5.07944 0.606935C5.0055 5.2444 2.63526 6.50133 1.33219 8.19449C-1.67499 12.1018 1.12166 16.3857 3.96953 17.1774C5.563 17.6205 3.60153 16.3936 3.34896 13.8022C3.04348 10.67 7.2043 8.27914 7.2043 5.68627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57051 7.26517C8.55228 7.25276 8.52627 7.2443 8.50843 7.27392C8.45942 7.85768 7.86283 9.10642 7.10668 10.2531C4.54201 14.1425 6.00354 16.0174 6.82532 17.0244C7.30253 17.609 6.82532 17.0244 8.01808 16.427C8.11147 16.3802 10.3453 15.128 10.5871 12.2752C10.8213 9.51246 9.16125 7.77108 8.57051 7.26517Z",
    fill: "#2483FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_7984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.928,
    height: 16.9245,
    fill: "white",
    transform: "translate(0.0361328 0.537727)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/huobi.61d220a55f793f3c3c7ca208c9fd822f.svg";
export { ForwardRef as ReactComponent };